module.exports = __webpack_public_path__ + "static/media/13.38495f7c.jpg";